import { render, staticRenderFns } from "./tiaoz.vue?vue&type=template&id=8741798e&scoped=true&"
import script from "./tiaoz.vue?vue&type=script&lang=js&"
export * from "./tiaoz.vue?vue&type=script&lang=js&"
import style0 from "./tiaoz.vue?vue&type=style&index=0&id=8741798e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8741798e",
  null
  
)

export default component.exports